import { styled } from 'linaria/react';
import theme from '@clad-ui/theme';
const {
  colors,
  radii,
  space,
  fontSizes,
  sizes,
  durations,
  fontWeights
} = theme;

/**
 *  @type {React.FC<any>}
 */
const StyledTooltip = /*#__PURE__*/styled("div")({
  name: "StyledTooltip",
  class: "svpm2x0",
  vars: {
    "svpm2x0-1": [({
      maxWidth
    }) => maxWidth],
    "svpm2x0-2": [({
      fadeDuration
    }) => durations[fadeDuration], "ms"],
    "svpm2x0-4": [({
      zIndex
    }) => zIndex]
  }
});
const ContentWrapper = /*#__PURE__*/styled("div")({
  name: "ContentWrapper",
  class: "c16l2vex"
});
const Thumbnail = /*#__PURE__*/styled("img")({
  name: "Thumbnail",
  class: "t4asf8r"
});
const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "c1i8wx01"
});
/**
 *  @type {React.FC<any>}
 */
const Title = /*#__PURE__*/styled("span")({
  name: "Title",
  class: "t1qeey6u"
});
const Text = /*#__PURE__*/styled("span")({
  name: "Text",
  class: "t1vplhhg"
});
const CloseIcon = /*#__PURE__*/styled("div")({
  name: "CloseIcon",
  class: "c1ljov3p"
});
export { StyledTooltip, Thumbnail, ContentWrapper, Content, Title, Text, CloseIcon };

require("../../../../../../../.linaria-cache/node_modules/.pnpm/clad-ui@0.20.20_mlt2zq6sucawkuesenn26jlwdu/node_modules/clad-ui/components/Tooltip/Tooltip.styles.linaria.module.css");